import axios from "axios";

let cachedBeverageMenu = null;
let pendingBeverageMenu = null;

export async function loadBeverageMenu(apiUrl, force = false) {
  if (!force && cachedBeverageMenu) {
    return cachedBeverageMenu;
  }

  if (!force && pendingBeverageMenu) {
    return pendingBeverageMenu;
  }

  pendingBeverageMenu = axios
    .get(`${apiUrl}Transaction/getDataBeverageMenu`)
    .then((res) => {
      if (res.data?.status === 0) {
        cachedBeverageMenu = res.data;
      }
      return res.data;
    })
    .finally(() => {
      pendingBeverageMenu = null;
    });

  return pendingBeverageMenu;
}

export function prefetchBeverageMenu(apiUrl) {
  if (cachedBeverageMenu || pendingBeverageMenu) {
    return;
  }

  loadBeverageMenu(apiUrl).catch(() => {});
}
